export default __webpack_public_path__ + "static/polygon-scatter-haikei-b5cfe84c8533d2628ff6f658d1769c11.svg";